const enterToNext = {
    inserted: function(el) {
        var arr = [...el.getElementsByTagName('input'), ...el.getElementsByTagName('button')];
        arr.forEach((item, i) => {
            item.addEventListener('keyup', (ev) => {
                if (ev.keyCode === 13 || ev.keyCode === 40) {
                    item.blur();
                    arr[i + 1].tagName === 'BUTTON' ? arr[i + 1].click() : arr[i + 1].focus();
                } else if (ev.keyCode === 38 && i != 0) {
                    item.blur();
                    arr[i - 1].focus();
                }
            })
        })

    }
}


export default {
    enterToNext,
}


// WEBPACK FOOTER //
// ./src/assets/js/directives.js